import type { ServiceView } from '@masterzapis/types';
import { durationLabel } from '../format';

interface Props {
  services: ServiceView[];
  onSelect: (service: ServiceView) => void;
}

export function ServicePicker({ services, onSelect }: Props) {
  if (services.length === 0) {
    return (
      <div className="empty-state">
        Мастер ещё не добавил услуги.
        <br />
        Загляните позже.
      </div>
    );
  }

  return (
    <div>
      <p className="section-title">Выберите услугу</p>
      {services.map((service) => (
        <button key={service.id} className="card" onClick={() => onSelect(service)}>
          <span className="card-row">
            <span className="card-name">{service.name}</span>
            <span className="card-price">{service.priceFormatted}</span>
          </span>
          <span className="card-meta">
            {durationLabel(service.durationMinutes)}
            {service.description ? ` · ${service.description}` : ''}
          </span>
        </button>
      ))}
    </div>
  );
}
